import { apiClient } from './client';
import type {
  TemplatesResponse,
  Template,
  CreateTemplateRequest,
  ApplyTemplateRequest,
  ApplyTemplateResponse,
} from '@affogato/shared';

export const templatesApi = {
  async getAll(): Promise<TemplatesResponse> {
    return apiClient.get('/templates');
  },

  async getById(id: string): Promise<Template> {
    return apiClient.get(`/templates/${id}`);
  },

  async create(data: CreateTemplateRequest): Promise<Template> {
    return apiClient.post('/templates', data);
  },

  async update(id: string, data: Partial<CreateTemplateRequest>): Promise<{ success: boolean }> {
    return apiClient.put(`/templates/${id}`, data);
  },

  async delete(id: string): Promise<{ success: boolean }> {
    return apiClient.delete(`/templates/${id}`);
  },

  async apply(id: string, data: ApplyTemplateRequest): Promise<ApplyTemplateResponse> {
    return apiClient.post(`/templates/${id}/apply`, data);
  },
};
